import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { loadConfig } from "./config";
import "./index.css";
import { AnnouncerProvider } from "./lib/announce";
import { PreferencesProvider } from "./lib/format";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } });

// Configuration first, then the app: one build serves every environment.
loadConfig().then((config) => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <PreferencesProvider>
          <AnnouncerProvider>
            <BrowserRouter>
              <App config={config} />
            </BrowserRouter>
          </AnnouncerProvider>
        </PreferencesProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
});
